import { v4 as uuidv4 } from "uuid";

export default {
  templateProgressType: "BUILD_FORM",
  form: {
    title: "Add a form title",
    description: "Add a form description",
    dropped: [],
    standardFields: {
      textField: [],
      url: [],
      paragraph: [],
      number: [],
      checkBox: [],
      dropDown: [],
      rating: [],
    },
    focusField: {},
    isEditing: false,
    submitConfig: {
      uid: uuidv4(),
      type: "submitBtn",
      name: "Submit",
      styleClasses: [],
    },
  },
  user: {
    data: {},
    status: "idle",
    error: null,
  },
  templates: {
    list: [],
    status: "idle",
    error: null,
    currentTemplate: {},
    updated: false,
    deleted: false,
  },
  formConfig: {
    configType: "CONFIRMATION_MESSAGE",
    messageBody: "<span>Thank you for submitting the form.</span>",
    messageText: "Thank you for submitting the form.",
    redirectWordpressPage: "home",
    redirectExternalPage: "",
    styleClasses: [],
  },
  integration: {
    configType: "INSTALLED_CRM",
    webhooks: [],
  },
  reviewAndEmbed: {},
};
